import Message from "./Message";
import '../css/messages_container.css'
import { useEffect } from "react";


function MessagesContainer({messages,  userId, setAnsweredMessage, answeredMessage}) {
    return <div className="messages-container" style={{'height': answeredMessage ? '60vh' : '73vh'}}>
        {messages.map((message) => (
            <Message message={message} userId={userId} setAnsweredMessage={setAnsweredMessage}/>
        ))}
    </div>
};

export default MessagesContainer;